import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {CommonModule, NgIf} from '@angular/common';
import {MenubarModule} from 'primeng/menubar';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {BadgeModule} from 'primeng/badge';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from 'primeng/api';
import {ToggleFeatureComponent} from '../toggle-feature/toggle-feature.component';
import {MatIconModule} from '@angular/material/icon';
import {TooltipModule} from 'primeng/tooltip';
import {HeaderMenuLoggedComponent} from '../header-menu-logged/header-menu-logged.component';
import {HeaderTextIconComponent} from '../header-text-icon/header-text-icon.component';

@Component({
  selector: 'app-header-web',
  templateUrl: './header-web.component.html',
  styleUrls: ['./header-web.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MenubarModule,
    ToolbarModule,
    ButtonModule,
    MenuModule,
    NgIf,
    BadgeModule,
    TranslateModule,
    SharedModule,
    ToggleFeatureComponent,
    MatIconModule,
    TooltipModule,
    HeaderMenuLoggedComponent,
    HeaderTextIconComponent
  ],
})
export class HeaderWebComponent  {
  @Output() toggleChange = new EventEmitter<boolean>(true);

  public displayToggleFeature = environment.displayToggleFeature;

}
